(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ab').forEach((root) => {
    const targets = Array.from(root.querySelectorAll('.ab-rv'));
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }),
      { threshold: 0.12 }
    );
    targets.forEach((el) => io.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-account"]) return;
  try {
    
  /*
   * Account: pane switching and the saved-pieces grid.
   *
   * Saved pieces are read from the same localStorage key the shop and world
   * pages write ({handle,title,image,url} under brando_saved), so a heart
   * tapped anywhere on the site shows up here without a customer metafield.
   */
  class BrandoAccount {
    constructor(root) {
      this.root = root;
      this.tabs = Array.from(root.querySelectorAll('[data-account-tab]'));
      this.panes = Array.from(root.querySelectorAll('[data-account-pane]'));
      this.tabsInit();
      this.saved();
    }

    tabsInit() {
      const show = (name, push) => {
        if (!this.panes.some((pane) => pane.dataset.accountPane === name)) return;
        this.tabs.forEach((tab) => tab.classList.toggle('is-on', tab.dataset.accountTab === name));
        this.panes.forEach((pane) => pane.classList.toggle('is-on', pane.dataset.accountPane === name));
        if (push) history.replaceState(null, '', `#${name}`);
      };

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => show(tab.dataset.accountTab, true));
      });

      const fromHash = window.location.hash.replace('#', '');
      if (fromHash) show(fromHash, false);
      window.addEventListener('hashchange', () => show(window.location.hash.replace('#', ''), false));
    }

    saved() {
      const grid = this.root.querySelector('[data-account-saved]');
      const empty = this.root.querySelector('[data-account-saved-empty]');
      if (!grid) return;

      let items = [];
      try {
        items = JSON.parse(window.localStorage.getItem('brando_saved') || '[]');
      } catch (e) {
        items = [];
      }
      items = items.filter((item) => item && item.url && item.title);

      grid.hidden = !items.length;
      if (empty) empty.hidden = !!items.length;
      if (!items.length) return;

      grid.innerHTML = '';
      items.forEach((item) => {
        const a = document.createElement('a');
        a.href = item.url;
        const img = item.image
          ? `<img src="${item.image}" alt="" loading="lazy">`
          : '';
        a.innerHTML = `<span class="ac-sv__im">${img}</span><span class="ac-sv__nm"></span>`;
        a.querySelector('.ac-sv__nm').textContent = item.title;
        grid.appendChild(a);
      });
    }
  }

  const initBrandoAccount = () => {
    document.querySelectorAll('[data-account]').forEach((root) => {
      if (root.dataset.accountReady) return;
      root.dataset.accountReady = 'true';
      new BrandoAccount(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoAccount);
  else initBrandoAccount();
  document.addEventListener('shopify:section:load', initBrandoAccount);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-cart"]) return;
  try {
    
  /*
   * <brando-cart> drives the cart over the Cart AJAX API and swaps its own
   * markup back in from ?section_id=, then refreshes the header bubble.
   *
   * Dawn's cart.js is deliberately not used: it hardcodes the main-cart-items /
   * main-cart-footer ids and looks for `.js-contents` inside each, which cannot
   * express this design's single-grid layout. Everything here still degrades to
   * the plain form when the element does not upgrade.
   */
  if (!customElements.get('brando-cart')) {
    customElements.define(
      'brando-cart',
      class BrandoCart extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.addEventListener('click', this.onClick.bind(this));
          this.addEventListener('change', this.onChange.bind(this));
        }

        onClick(event) {
          const step = event.target.closest('[data-cart-step]');
          if (step) {
            event.preventDefault();
            const row = step.closest('[data-cart-line]');
            const input = row.querySelector('[data-cart-qty]');
            const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.cartStep, 10));
            this.change(row.dataset.cartLine, next);
            return;
          }

          const remove = event.target.closest('[data-cart-remove]');
          if (remove) {
            event.preventDefault();
            this.change(remove.closest('[data-cart-line]').dataset.cartLine, 0);
          }
        }

        onChange(event) {
          const input = event.target.closest('[data-cart-qty]');
          if (!input) return;
          const row = input.closest('[data-cart-line]');
          this.change(row.dataset.cartLine, Math.max(0, parseInt(input.value, 10) || 0));
        }

        change(line, quantity) {
          this.classList.add('is-busy');
          fetch(`${window.routes.cart_change_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(line), quantity: quantity }),
          })
            .then((response) => response.json())
            .then((state) => {
              if (state.status) {
                this.error(state.description || state.message);
                return null;
              }
              return this.refresh();
            })
            .catch(() => this.error(window.cartStrings ? window.cartStrings.error : 'Something went wrong.'))
            .finally(() => this.classList.remove('is-busy'));
        }

        /* Re-render this section, then the header cart bubble. */
        refresh() {
          return fetch(`${window.routes.cart_url}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((text) => {
              const doc = new DOMParser().parseFromString(text, 'text/html');
              const fresh = doc.querySelector('brando-cart');
              if (fresh) this.innerHTML = fresh.innerHTML;
              return fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`);
            })
            .then((response) => (response ? response.text() : null))
            .then((text) => {
              if (!text) return;
              // The bubble section renders only the icon and count; the id lives
              // on the header's anchor, so take the .shopify-section wrapper's
              // contents (the same selector Dawn's own cart.js uses).
              const bubble = document.getElementById('cart-icon-bubble');
              const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
              if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
              document.dispatchEvent(new CustomEvent('brando:cart:updated'));
            });
        }

        error(message) {
          const box = this.querySelector('[data-cart-error]');
          if (box) box.textContent = message;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-family"] && !Shopify.designMode) return;
  try {
    
  /*
   * Brando & Co family page: scroll reveals, the size chooser (cards and buy
   * bar stay in sync, and the matching Dawn product form is the one mounted),
   * quantity, the cm/in toggle, and ducking the bar under the footer.
   */
  class BrandoFamily {
    constructor(root) {
      this.root = root;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.reveals();
      this.sizes();
      this.quantity();
      this.units();
      this.buybar();
    }

    reveals() {
      const targets = Array.from(this.root.querySelectorAll('.fam-rv'));
      if (!targets.length) return;
      if (this.reduced || !('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }),
        { threshold: 0.12 }
      );
      targets.forEach((el) => io.observe(el));
    }

    sizes() {
      const buttons = Array.from(this.root.querySelectorAll('[data-fam-size]'));
      if (!buttons.length) return;
      const selectLabel = this.root.dataset.selectLabel || 'Select';
      const selectedLabel = this.root.dataset.selectedLabel || 'Selected';

      const select = (id) => {
        this.current = id;
        buttons.forEach((btn) => {
          const on = btn.dataset.famSize === id;
          btn.classList.toggle('is-on', on);
          if (btn.classList.contains('fam-size')) {
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            const pick = btn.querySelector('.fam-size__pick');
            if (pick) pick.textContent = on ? selectedLabel : selectLabel;
          }
        });
        ['[data-fam-price]', '[data-fam-form]', '[data-fam-link]'].forEach((selector) => {
          this.root.querySelectorAll(selector).forEach((el) => {
            const key = el.dataset.famPrice || el.dataset.famForm || el.dataset.famLink;
            el.hidden = key !== id;
          });
        });
        this.syncQuantity();
      };

      buttons.forEach((btn) => btn.addEventListener('click', () => select(btn.dataset.famSize)));
      const first = this.root.querySelector('.fam-size.is-on') || buttons[0];
      select(first.dataset.famSize);
    }

    /* Keep every member's hidden quantity input in step with the readout. */
    syncQuantity() {
      const n = this.qty || 1;
      this.root.querySelectorAll('[data-fam-qty-input]').forEach((input) => { input.value = n; });
      const readout = this.root.querySelector('[data-fam-qty-n]');
      if (readout) readout.textContent = n;
    }

    quantity() {
      this.qty = 1;
      this.root.querySelectorAll('[data-fam-qty-step]').forEach((button) => {
        button.addEventListener('click', () => {
          this.qty = Math.max(1, this.qty + parseInt(button.dataset.famQtyStep, 10));
          this.syncQuantity();
        });
      });
      this.syncQuantity();
    }

    units() {
      const toggle = this.root.querySelector('[data-fam-unit]');
      if (!toggle) return;
      const values = Array.from(this.root.querySelectorAll('[data-fam-cm]'));
      toggle.querySelectorAll('[data-fam-u]').forEach((button) => {
        button.addEventListener('click', () => {
          toggle.querySelectorAll('[data-fam-u]').forEach((other) => other.classList.toggle('is-on', other === button));
          const inches = button.dataset.famU === 'in';
          values.forEach((el) => {
            const cm = parseFloat(el.dataset.famCm);
            if (isNaN(cm)) return;
            el.textContent = inches ? `${(cm / 2.54).toFixed(1).replace(/\.0$/, '')} in` : `${cm} cm`;
          });
        });
      });
    }

    buybar() {
      const bar = this.root.querySelector('[data-fam-buybar]');
      if (!bar || !('IntersectionObserver' in window)) return;
      const footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
      if (!footer) return;
      new IntersectionObserver(
        (entries) => entries.forEach((entry) => bar.classList.toggle('is-hidden', entry.isIntersecting)),
        { threshold: 0.05 }
      ).observe(footer);
    }
  }

  const initBrandoFamily = () => {
    document.querySelectorAll('[data-family]').forEach((root) => {
      if (root.dataset.familyReady) return;
      root.dataset.familyReady = 'true';
      new BrandoFamily(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoFamily);
  else initBrandoFamily();
  document.addEventListener('shopify:section:load', initBrandoFamily);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-find"] && !Shopify.designMode) return;
  try {
    
  /*
   * Find Your Piece: hero intro, the floating search bar's show/hide past
   * the hero (and its count refreshed from the real page-load result, since
   * a true live count would need a predictive-search request per keystroke),
   * scroll reveals for the index columns, and the sort <select> driving the
   * hidden real GET form so search stays server side.
   */
  class BrandoFind {
    constructor(root) {
      this.root = root;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.intro();
      this.reveals();
      this.searchBar();
      this.sortSelect();
    }

    intro() {
      const show = () => this.root.classList.add('is-loaded');
      if (document.readyState === 'complete') window.setTimeout(show, 80);
      else window.addEventListener('load', () => window.setTimeout(show, 80));
      window.setTimeout(show, 1800);
    }

    reveals() {
      const targets = Array.from(this.root.querySelectorAll('.fp-rv'));
      if (!targets.length) return;
      if (this.reduced || !('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }),
        { threshold: 0.12 }
      );
      targets.forEach((el) => io.observe(el));
    }

    searchBar() {
      const bar = this.root.querySelector('[data-find-bar]');
      const hero = this.root.querySelector('.fp-hero');
      if (!bar || !hero) return;
      const onScroll = () => bar.classList.toggle('is-shown', window.scrollY > hero.offsetHeight - 120);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    sortSelect() {
      const select = this.root.querySelector('[data-find-sort]');
      const form = this.root.querySelector('form[id^="FindSortForm-"]');
      if (!select) return;
      const params = new URLSearchParams(window.location.search);
      if (params.has('sort_by')) select.value = params.get('sort_by');
      select.addEventListener('change', () => {
        if (form) {
          form.querySelector('[data-find-sort-input]').value = select.value;
          form.submit();
          return;
        }
        params.set('sort_by', select.value);
        window.location.search = params.toString();
      });
    }
  }

  const initBrandoFind = () => {
    document.querySelectorAll('[data-find]').forEach((root) => {
      if (root.dataset.findReady) return;
      root.dataset.findReady = 'true';
      new BrandoFind(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoFind);
  else initBrandoFind();
  document.addEventListener('shopify:section:load', initBrandoFind);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-homepage"] && !Shopify.designMode) return;
  try {
    
  /*
   * Homepage: hero intro + parallax, hotspot panel (hydrated from the
   * button's own data attributes, set server side from real product data),
   * the "tap a marker" tour, the hero film, and scroll reveals.
   */
  class BrandoHomepage {
    constructor(root) {
      this.root = root;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.intro();
      this.reveals();
      this.hotspots();
      this.parallax();
      this.films();
      this.cue();
    }

    /* Phone scroll cue: tap scrolls past the hero; it fades once the page moves. */
    cue() {
      const cue = this.root.querySelector('[data-hp-cue]');
      const hero = this.root.querySelector('[data-hp-hero]');
      if (!cue || !hero) return;
      cue.addEventListener('click', () => {
        const y = hero.getBoundingClientRect().bottom + window.scrollY;
        window.scrollTo({ top: y, behavior: this.reduced ? 'auto' : 'smooth' });
      });
      const onScroll = () => {
        const gone = window.scrollY > 40;
        cue.classList.toggle('is-gone', gone);
        if (gone) cue.classList.add('is-seen');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Load and play only the film the current width shows; the hidden crop never downloads. */
    films() {
      const vids = [...this.root.querySelectorAll('[data-hp-film]')];
      if (!vids.length || this.reduced) return;
      const sync = () => vids.forEach((v) => {
        if (v.offsetParent === null) { v.pause(); return; }
        if (!v.getAttribute('src')) v.src = v.dataset.hpFilm;
        const p = v.play();
        if (p) p.catch(() => {});
      });
      sync();
      window.matchMedia('(max-width: 900px)').addEventListener('change', sync);
    }

    intro() {
      const show = () => this.root.classList.add('is-loaded');
      if (document.readyState === 'complete') window.setTimeout(show, 80);
      else window.addEventListener('load', () => window.setTimeout(show, 80));
      window.setTimeout(show, 1800);
    }

    reveals() {
      const targets = Array.from(this.root.querySelectorAll('.hp-rv'));
      if (!targets.length) return;
      if (this.reduced || !('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }),
        { rootMargin: '0px 0px -6% 0px' }
      );
      targets.forEach((el) => io.observe(el));
    }

    hotspots() {
      const hero = this.root.querySelector('[data-hp-hero]');
      const panel = this.root.querySelector('[data-hp-panel]');
      const spots = Array.from(this.root.querySelectorAll('[data-hp-spot]'));
      if (!hero || !panel || !spots.length) return;

      let open = null;
      const close = () => {
        panel.classList.remove('is-shown');
        hero.classList.remove('is-card-open');
        if (open) open.classList.remove('is-open');
        open = null;
      };

      spots.forEach((spot) => {
        spot.addEventListener('click', (event) => {
          event.stopPropagation();
          if (open === spot) {
            close();
            return;
          }
          if (open) open.classList.remove('is-open');
          open = spot;
          spot.classList.add('is-open');

          panel.querySelector('[data-hp-panel-name]').textContent = spot.dataset.hpName || '';
          panel.querySelector('[data-hp-panel-type]').textContent = spot.dataset.hpType || '';
          panel.querySelector('[data-hp-panel-blurb]').textContent = spot.dataset.hpBlurb || '';
          panel.querySelector('[data-hp-panel-meta]').textContent = spot.dataset.hpMat || '';
          const go = panel.querySelector('[data-hp-panel-go]');
          if (go) go.href = spot.dataset.hpGo || '#';

          // Point the focus vignette at the tapped marker.
          if (spot.style.left) hero.style.setProperty('--hx', spot.style.left);
          if (spot.style.top) hero.style.setProperty('--hy', spot.style.top);

          panel.classList.add('is-shown');
          hero.classList.add('is-card-open');
        });
      });

      hero.addEventListener('click', close);
      panel.addEventListener('click', (event) => event.stopPropagation());
      const closeBtn = this.root.querySelector('[data-hp-panel-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && open) close();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && open) close();
      });

      // "Tap a marker to meet them" doubles as a tour once opened.
      const hint = this.root.querySelector('[data-hp-hint]');
      const hintText = this.root.querySelector('[data-hp-hint-text]');
      if (hint) {
        let tourIndex = -1;
        hint.addEventListener('click', (event) => {
          event.stopPropagation();
          tourIndex = (tourIndex + 1) % spots.length;
          spots[tourIndex].click();
          if (hintText) hintText.textContent = hint.dataset.hpNextLabel || 'Next piece →';
        });
      }
    }

    parallax() {
      if (this.reduced) return;
      const par = this.root.querySelector('[data-hp-parallax]');
      const copy = this.root.querySelector('.hp-hero__copy');
      if (!par) return;
      window.addEventListener(
        'scroll',
        () => {
          const y = window.scrollY;
          par.style.transform = `translateY(${y * 0.25}px)`;
          if (copy) {
            const fade = Math.min(y / (window.innerHeight * 0.55), 1);
            copy.style.transform = `translateY(${y * -0.12}px)`;
            copy.style.opacity = String(1 - fade * 0.9);
          }
        },
        { passive: true }
      );
    }
  }

  const initBrandoHomepage = () => {
    document.querySelectorAll('[data-homepage]').forEach((root) => {
      if (root.dataset.homepageReady) return;
      root.dataset.homepageReady = 'true';
      new BrandoHomepage(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoHomepage);
  else initBrandoHomepage();
  document.addEventListener('shopify:section:load', initBrandoHomepage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-rooms"] && !Shopify.designMode) return;
  try {
    
  /* Rooms: the photographs fade up as they arrive. */
  const initBrandoRooms = () => {
    document.querySelectorAll('[data-rooms]').forEach((root) => {
      if (root.dataset.roomsReady) return;
      root.dataset.roomsReady = 'true';

      const targets = Array.from(root.querySelectorAll('.rooms-rv'));
      if (!targets.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }),
        { rootMargin: '0px 0px -6% 0px' }
      );
      targets.forEach((el) => io.observe(el));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoRooms);
  else initBrandoRooms();
  document.addEventListener('shopify:section:load', initBrandoRooms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-saved"]) return;
  try {
    
  /*
   * Saved: every product in the source collection is already server
   * rendered as a hidden card carrying its own real data. This just reads
   * brando_saved and shows the matching cards, in save order, prepending
   * each into the grid so order matches the list. A saved handle that no
   * longer matches a rendered card (removed or unpublished product) is
   * shown from its own stored title/image/url instead of being dropped
   * silently.
   */
  const initBrandoSaved = () => {
    document.querySelectorAll('[data-saved]').forEach((root) => {
      if (root.dataset.savedReady) return;
      root.dataset.savedReady = 'true';

      const grid = root.querySelector('[data-saved-grid]');
      const empty = root.querySelector('[data-saved-empty]');
      const countEl = root.querySelector('[data-saved-count]');
      const cardsByHandle = new Map(
        Array.from(root.querySelectorAll('[data-saved-card]')).map((card) => [card.dataset.handle, card])
      );

      const read = () => {
        try {
          return JSON.parse(window.localStorage.getItem('brando_saved') || '[]');
        } catch (e) {
          return [];
        }
      };
      const write = (value) => {
        try {
          window.localStorage.setItem('brando_saved', JSON.stringify(value));
        } catch (e) {
          /* private mode */
        }
      };

      let saved = read();

      const buildFallbackCard = (item) => {
        const a = document.createElement('a');
        a.className = 'sv-card';
        a.href = item.url || '#';
        a.dataset.savedCard = '';
        a.dataset.handle = item.handle || '';
        a.innerHTML =
          '<button class="sv-card__un" type="button" data-saved-remove aria-label="Remove from saved">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10z"></path></svg></button>' +
          '<span class="sv-card__im"></span><span class="sv-card__nm"></span>';
        if (item.image) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title || '';
          img.loading = 'lazy';
          a.querySelector('.sv-card__im').appendChild(img);
        }
        a.querySelector('.sv-card__nm').textContent = item.title || '';
        return a;
      };

      const render = () => {
        Array.from(grid.children).forEach((child) => {
          if (!cardsByHandle.has(child.dataset.handle)) child.remove();
        });
        cardsByHandle.forEach((card) => {
          card.hidden = true;
        });

        saved.forEach((item) => {
          const known = item && item.handle ? cardsByHandle.get(item.handle) : null;
          const node = known || buildFallbackCard(item);
          node.hidden = false;
          grid.appendChild(node);
        });

        const shown = saved.length;
        empty.hidden = shown > 0;
        if (countEl) {
          countEl.textContent = shown ? `${shown} ${shown === 1 ? 'piece' : 'pieces'}, kept for later.` : '';
        }
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-saved-remove]');
        if (!button) return;
        event.preventDefault();
        const card = button.closest('[data-saved-card]');
        if (!card) return;
        saved = saved.filter((item) => item.handle !== card.dataset.handle);
        write(saved);
        render();
      });

      render();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoSaved);
  else initBrandoSaved();
  document.addEventListener('shopify:section:load', initBrandoSaved);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-search"]) return;
  try {
    
  /*
   * Search: filters the server-rendered cards in place. Each card carries a
   * data-hay haystack built in Liquid, so a keystroke is a string match
   * rather than a request. The surrounding <form> still GETs Shopify search,
   * which is what runs with JavaScript off.
   */
  class BrandoSearch {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-search-form]');
      this.input = root.querySelector('[data-search-input]');
      this.grid = root.querySelector('[data-search-grid]');
      this.cards = Array.from(root.querySelectorAll('[data-search-card]'));
      this.meta = root.querySelector('[data-search-meta]');
      this.empty = root.querySelector('[data-search-empty]');
      this.emptyQ = root.querySelector('[data-search-empty-q]');
      this.clear = root.querySelector('[data-search-clear]');
      if (!this.input || !this.grid) return;

      this.total = this.cards.length;
      this.allLabel = this.grid.dataset.allLabel || '';

      // With JS available the filtering is local, so don't navigate away.
      if (this.form) this.form.addEventListener('submit', (e) => e.preventDefault());

      this.input.addEventListener('input', () => this.run());
      if (this.clear) {
        this.clear.addEventListener('click', () => {
          this.input.value = '';
          this.run();
          this.input.focus();
        });
      }

      const chips = this.root.querySelector('[data-search-chips]');
      if (chips) {
        chips.addEventListener('click', (event) => {
          const button = event.target.closest('[data-search-chip]');
          if (!button) return;
          this.input.value = button.dataset.searchChip;
          this.run();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }

      this.run();
      if (!this.input.value && window.matchMedia('(min-width: 901px)').matches) this.input.focus();
    }

    /* Fold the odd spelling people actually type. */
    normalise(value) {
      return value
        .toLowerCase()
        .replace(/boucle/g, 'bouclé')
        .trim();
    }

    run() {
      const raw = this.input.value.trim();
      const value = this.normalise(raw);
      if (this.form) this.form.classList.toggle('has-value', !!raw);

      let shown = 0;
      if (!value) {
        this.cards.forEach((card) => {
          card.hidden = false;
        });
        shown = this.total;
      } else {
        const words = value.split(/\s+/);
        this.cards.forEach((card) => {
          const hay = card.dataset.hay || '';
          const hit = words.every((word) => hay.includes(word));
          card.hidden = !hit;
          if (hit) shown += 1;
        });
      }

      if (this.empty) {
        this.empty.hidden = shown > 0;
        if (this.emptyQ) this.emptyQ.textContent = raw;
      }
      if (this.meta) {
        if (!value) {
          this.meta.textContent = this.meta.dataset.allText
            ? this.meta.dataset.allText.replace('[count]', this.total)
            : `All ${this.total} pieces.`;
        } else {
          this.meta.textContent = shown
            ? `${shown} ${shown === 1 ? 'piece' : 'pieces'} for “${raw}”.`
            : '';
        }
      }
    }
  }

  const initBrandoSearch = () => {
    document.querySelectorAll('[data-search]').forEach((root) => {
      if (root.dataset.searchReady) return;
      root.dataset.searchReady = 'true';
      new BrandoSearch(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoSearch);
  else initBrandoSearch();
  document.addEventListener('shopify:section:load', initBrandoSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-shop"] && !Shopify.designMode) return;
  try {
    
  /*
   * Brando & Co Shop behaviour: card reveals, the sticky rail (arrows + the
   * condensed state once it sticks), the inline search bar (client-side filter
   * of the loaded grid; Enter submits to the real search page), grid density,
   * hearts (saved) and the recently viewed row. State lives in localStorage
   * under brando_saved / brando_recent / brando_density, shared with the PDP.
   */
  class BrandoShop {
    constructor(root) {
      this.root = root;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.grid = root.querySelector('[data-shop-grid]');
      this.cards = Array.from(root.querySelectorAll('[data-shop-card]'));
      this.extras = Array.from(root.querySelectorAll('[data-shop-extra]'));
      this.strap = root.querySelector('[data-shop-strap]');
      this.saved = this.read('brando_saved');
      this.reveals();
      this.rail();
      this.search();
      this.density();
      this.hearts();
      this.recent();
    }

    read(key) {
      try { return JSON.parse(window.localStorage.getItem(key) || '[]'); } catch (e) { return []; }
    }
    write(key, value) {
      try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
    }

    reveals() {
      const targets = this.cards.concat(Array.from(this.root.querySelectorAll('.shop-rv:not(.is-in)')));
      if (!targets.length) return;
      if (this.reduced || !('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }),
        { threshold: 0.05, rootMargin: '0px 0px 80px 0px' }
      );
      targets.forEach((el) => io.observe(el));
    }

    rail() {
      const wrap = this.root.querySelector('[data-shop-railwrap]');
      const track = this.root.querySelector('[data-shop-rail]');
      if (!wrap || !track) return;

      const arrows = Array.from(wrap.querySelectorAll('[data-shop-arr]'));
      arrows.forEach((arrow) => arrow.addEventListener('click', () => {
        track.scrollBy({ left: 460 * parseInt(arrow.dataset.shopArr, 10), behavior: this.reduced ? 'auto' : 'smooth' });
      }));
      const update = () => {
        arrows.forEach((arrow) => {
          const dir = parseInt(arrow.dataset.shopArr, 10);
          arrow.hidden = dir < 0 ? track.scrollLeft < 20 : track.scrollLeft > track.scrollWidth - track.clientWidth - 20;
        });
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();

      // Scroll the active category into view on load.
      const active = track.querySelector('.shop-cat.is-on');
      if (active && active.offsetLeft + active.offsetWidth > track.clientWidth) {
        track.scrollLeft = active.offsetLeft - 48;
      }

      const sentinel = this.root.querySelector('[data-shop-railsentinel]');
      if (!sentinel || !('IntersectionObserver' in window)) return;
      const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 64;
      new IntersectionObserver(
        ([entry]) => wrap.classList.toggle('is-stuck', !entry.isIntersecting),
        { rootMargin: `-${headerH + 16}px 0px 0px 0px` }
      ).observe(sentinel);
    }

    setStrap(html) {
      if (this.strap) this.strap.innerHTML = html;
    }
    escape(text) {
      return String(text).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    search() {
      const bar = this.root.querySelector('[data-shop-sbar]');
      const input = this.root.querySelector('[data-shop-q]');
      if (!bar || !input) return;
      this.noResults = this.root.querySelector('[data-shop-noresults]');

      const open = (event) => {
        if (event) event.preventDefault();
        bar.classList.add('is-open');
        input.focus();
      };
      this.root.querySelectorAll('[data-shop-open-search]').forEach((btn) => btn.addEventListener('click', open));
      // The global mobile tab bar's Search opens the inline bar on this page.
      document.querySelectorAll('[data-tabbar-search]').forEach((link) => link.addEventListener('click', open));

      const filter = () => {
        const q = input.value.trim().toLowerCase();
        let shown = 0;
        this.cards.forEach((card) => {
          const hit = !q || (card.dataset.search || '').indexOf(q) !== -1;
          card.hidden = !hit;
          if (hit) shown += 1;
        });
        this.extras.forEach((el) => { el.hidden = !!q; });
        if (this.noResults) this.noResults.hidden = !q || shown > 0;
        if (!this.strap) return;
        if (q) {
          this.setStrap(`Results for <em>&ldquo;${this.escape(input.value.trim())}&rdquo; - ${shown} piece${shown === 1 ? '' : 's'}.</em>`);
        } else {
          this.setStrap(`${this.escape(this.strap.dataset.default)} <em>${this.escape(this.strap.dataset.defaultEm)}</em>`);
        }
      };
      input.addEventListener('input', filter);

      const close = this.root.querySelector('[data-shop-qx]');
      if (close) close.addEventListener('click', () => {
        input.value = '';
        filter();
        bar.classList.remove('is-open');
      });

      // Arrive from ?q= (the tab bar links here): open the bar prefilled.
      const params = new URLSearchParams(window.location.search);
      if (params.get('q')) {
        input.value = params.get('q');
        bar.classList.add('is-open');
        filter();
      }
    }

    density() {
      const seg = this.root.querySelector('[data-shop-density]');
      if (!seg || !this.grid) return;
      const set = (value) => {
        this.grid.classList.toggle('is-compact', value === 'compact');
        seg.querySelectorAll('[data-shop-d]').forEach((b) => b.classList.toggle('is-on', b.dataset.shopD === value));
        try { window.localStorage.setItem('brando_density', value); } catch (e) { /* noop */ }
      };
      seg.querySelectorAll('[data-shop-d]').forEach((b) => b.addEventListener('click', () => set(b.dataset.shopD)));
      try { if (window.localStorage.getItem('brando_density') === 'compact') set('compact'); } catch (e) { /* noop */ }
    }

    rowCard(item) {
      const a = document.createElement('a');
      a.className = 'shop-rp';
      a.href = item.url;
      a.innerHTML = `<span class="shop-rp__im">${item.image ? `<img src="${this.escape(item.image)}" alt="${this.escape(item.title)}" loading="lazy" />` : ''}</span><span class="shop-rp__nm">${this.escape(item.title)}</span>`;
      return a;
    }

    renderRow(section, row, items) {
      if (!section || !row) return;
      row.innerHTML = '';
      const list = items.filter((i) => i && i.url && i.title);
      section.hidden = !list.length;
      list.forEach((i) => row.appendChild(this.rowCard(i)));
    }

    hearts() {
      const section = this.root.querySelector('[data-shop-saved]');
      const row = this.root.querySelector('[data-shop-saved-row]');
      const has = (handle) => this.saved.some((i) => i.handle === handle);
      const paint = () => {
        this.cards.forEach((card) => {
          const on = has(card.dataset.handle);
          const btn = card.querySelector('[data-shop-save]');
          if (!btn) return;
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.renderRow(section, row, this.saved);
      };
      paint();

      this.root.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-shop-save]');
        if (!btn) return;
        event.preventDefault();
        event.stopPropagation();
        const card = btn.closest('[data-shop-card]');
        if (!card) return;
        const item = { handle: card.dataset.handle, title: card.dataset.title, image: card.dataset.image, url: card.dataset.url };
        if (has(item.handle)) this.saved = this.saved.filter((i) => i.handle !== item.handle);
        else this.saved.unshift(item);
        this.saved = this.saved.slice(0, 20);
        this.write('brando_saved', this.saved);
        paint();
      });
    }

    recent() {
      const section = this.root.querySelector('[data-shop-recent]');
      const row = this.root.querySelector('[data-shop-recent-row]');
      this.renderRow(section, row, this.read('brando_recent'));
    }
  }

  const initBrandoShop = () => {
    document.querySelectorAll('[data-shop]').forEach((root) => {
      if (root.dataset.shopReady) return;
      root.dataset.shopReady = 'true';
      new BrandoShop(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoShop);
  else initBrandoShop();
  document.addEventListener('shopify:section:load', initBrandoShop);

  // The header's search icon links here with #shop-search: open the bar and
  // focus it on arrival, so search lives on the Shop page rather than a modal.
  (function () {
    function openFromHash(root) {
      if (window.location.hash !== '#shop-search') return;
      var btn = root.querySelector('[data-shop-open-search]');
      var input = root.querySelector('[data-shop-q]');
      if (btn) btn.click();
      if (input) { input.focus({ preventScroll: true }); }
    }
    document.querySelectorAll('.shop').forEach(openFromHash);
    window.addEventListener('hashchange', function () {
      document.querySelectorAll('.shop').forEach(openFromHash);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brando-world"] && !Shopify.designMode) return;
  try {
    
  /*
   * World page behaviour: the hero intro, card reveals on scroll, and the
   * hearts. Saved pieces share the shop's localStorage shape
   * ({handle,title,image,url} under brando_saved) so the shop's Saved row and
   * the account page pick them up unchanged.
   */
  class BrandoWorld {
    constructor(root) {
      this.root = root;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.cards = Array.from(root.querySelectorAll('[data-world-card]'));
      this.saved = this.read('brando_saved');
      this.intro();
      this.reveals();
      this.hearts();
    }

    read(key) {
      try { return JSON.parse(window.localStorage.getItem(key) || '[]'); } catch (e) { return []; }
    }
    write(key, value) {
      try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
    }

    intro() {
      const show = () => this.root.classList.add('is-loaded');
      if (document.readyState === 'complete') window.setTimeout(show, 60);
      else window.addEventListener('load', () => window.setTimeout(show, 60));
      window.setTimeout(show, 1200);
    }

    reveals() {
      if (!this.cards.length) return;
      if (this.reduced || !('IntersectionObserver' in window)) {
        this.cards.forEach((el) => el.classList.add('is-in'));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }),
        { rootMargin: '0px 0px -8% 0px' }
      );
      this.cards.forEach((el) => io.observe(el));
    }

    hearts() {
      const has = (handle) => this.saved.some((i) => i.handle === handle);
      const paint = () => {
        this.cards.forEach((card) => {
          const on = has(card.dataset.handle);
          const btn = card.querySelector('[data-world-save]');
          if (!btn) return;
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      };
      paint();

      this.root.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-world-save]');
        if (!btn) return;
        event.preventDefault();
        event.stopPropagation();
        const card = btn.closest('[data-world-card]');
        if (!card) return;
        const item = {
          handle: card.dataset.handle,
          title: card.dataset.title,
          image: card.dataset.image,
          url: card.dataset.url,
        };
        if (has(item.handle)) this.saved = this.saved.filter((i) => i.handle !== item.handle);
        else this.saved.unshift(item);
        this.saved = this.saved.slice(0, 20);
        this.write('brando_saved', this.saved);
        paint();
      });
    }
  }

  const initBrandoWorld = () => {
    document.querySelectorAll('[data-world]').forEach((root) => {
      if (root.dataset.worldReady) return;
      root.dataset.worldReady = 'true';
      new BrandoWorld(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoWorld);
  else initBrandoWorld();
  document.addEventListener('shopify:section:load', initBrandoWorld);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class BrandoHeader extends HTMLElement {
    connectedCallback() {
      this.isHome = this.hasAttribute('data-home');
      this.setHeight();
      this.onResize = () => this.setHeight();
      window.addEventListener('resize', this.onResize, { passive: true });

      this.mobile = window.matchMedia('(max-width: 900px)');
      this.onScroll = () => {
        if (this.isHome) {
          if (window.scrollY > 40) {
            this.classList.remove('brando-header--transparent');
          } else {
            this.classList.add('brando-header--transparent');
          }
        }
        // Mobile: the bar slides away once the page has scrolled, and comes
        // back only at the top. Desktop keeps it.
        const away = this.mobile.matches && window.scrollY > 80;
        if (away !== this.classList.contains('brando-header--away')) {
          this.classList.toggle('brando-header--away', away);
          this.setOffset();
        }
      };
      this.onScroll();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.mobile.addEventListener('change', this.onScroll);

      this.mega();
    }

    /*
     * Mega panels: one per nav item that enables it. Hovering a trigger opens
     * its own panel and closes any other; hovering a plain nav link, leaving
     * the header, or pressing Escape closes them all. Desktop only - the CSS
     * keeps the panels hidden below 990px, where the drawer takes over.
     */
    mega() {
      const panels = Array.from(this.querySelectorAll('[data-mega-panel]'));
      if (!panels.length) return;
      const triggers = Array.from(this.querySelectorAll('[data-mega-trigger]'));

      const closeAll = () => {
        panels.forEach((panel) => panel.classList.remove('is-open'));
        triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.classList.remove('brando-header--mega-open');
      };

      const open = (id) => {
        let found = false;
        panels.forEach((panel) => {
          const on = panel.dataset.megaPanel === id;
          panel.classList.toggle('is-open', on);
          if (on) found = true;
        });
        triggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', trigger.dataset.megaTrigger === id ? 'true' : 'false');
        });
        this.classList.toggle('brando-header--mega-open', found);
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => open(trigger.dataset.megaTrigger));
        trigger.addEventListener('focus', () => open(trigger.dataset.megaTrigger));
      });

      this.querySelectorAll('.brando-nav__link').forEach((link) => {
        if (link.hasAttribute('data-mega-trigger')) return;
        link.addEventListener('mouseenter', closeAll);
      });

      this.addEventListener('mouseleave', closeAll);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeAll();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        this.mobile.removeEventListener('change', this.onScroll);
      }
    }

    setHeight() {
      document.documentElement.style.setProperty('--header-height', this.offsetHeight + 'px');
      this.setOffset();
    }

    /*
     * --header-offset is the height the header currently occupies at the top
     * of the viewport: its full height while shown, 0 once it has slid away
     * on mobile. Sticky rails and sub navs pin to this rather than to the
     * fixed --header-height, so they rise to the top edge with it.
     */
    setOffset() {
      const away = this.classList.contains('brando-header--away');
      document.documentElement.style.setProperty('--header-offset', (away ? 0 : this.offsetHeight) + 'px');
    }
  }

  customElements.define('brando-header', BrandoHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-brando-hero]').forEach(function (hero) {
      var spots = hero.querySelectorAll('[data-hero-spot]');
      if (!spots.length) return;

      function closeAll(except) {
        spots.forEach(function (spot) {
          if (spot === except) return;
          spot.classList.remove('is-open');
          var btn = spot.querySelector('[data-hero-dot]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }

      spots.forEach(function (spot) {
        var dot = spot.querySelector('[data-hero-dot]');
        if (!dot) return;
        dot.addEventListener('click', function (event) {
          event.stopPropagation();
          var isOpen = spot.classList.contains('is-open');
          closeAll(spot);
          if (isOpen) {
            spot.classList.remove('is-open');
            dot.setAttribute('aria-expanded', 'false');
          } else {
            spot.classList.add('is-open');
            dot.setAttribute('aria-expanded', 'true');
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (!hero.contains(event.target) || !event.target.closest('[data-hero-spot]')) {
          closeAll(null);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /*
   * Brando & Co PDP behaviour: hero intro, scroll reveals, the sticky sub nav,
   * the buy bar (quantity, variant-driven price line, hide over the footer),
   * and the cm/in dimension toggle.
   *
   * Variant state comes from Dawn: <variant-selects> publishes the change and
   * product-info.js swaps #price-{sectionId} in place, so this only mirrors the
   * label and the instalment line.
   */
  class BrandoPdp {
    constructor(root) {
      this.root = root;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.intro();
      this.reveals();
      this.subnav();
      this.quantity();
      this.buybar();
      this.save();
      this.addToast();
      this.fitViews();
      this.units();
      this.drawIn();
      this.variants();
      this.hotspot();
      this.track();
    }

    /*
     * Record this product in the shared "recently viewed" list that the Shop
     * page renders. Same localStorage key and shape as the Shop's hearts.
     */
    track() {
      const { handle, title, image, url } = this.root.dataset;
      if (!handle || !title) return;
      try {
        const key = 'brando_recent';
        const seen = JSON.parse(window.localStorage.getItem(key) || '[]').filter((i) => i && i.handle !== handle);
        seen.unshift({ handle, title, image: image || '', url: url || '' });
        window.localStorage.setItem(key, JSON.stringify(seen.slice(0, 8)));
      } catch (error) {
        /* private mode - the row simply stays empty */
      }
    }

    intro() {
      const show = () => this.root.classList.add('is-loaded');
      if (document.readyState === 'complete') window.setTimeout(show, 60);
      else window.addEventListener('load', () => window.setTimeout(show, 60));
      window.setTimeout(show, 1500);
    }

    reveals() {
      const targets = Array.from(this.root.querySelectorAll('.pdp-rv'));
      if (!targets.length) return;
      if (this.reduced || !('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }
      const io = new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }),
        { threshold: 0.12 }
      );
      targets.forEach((el) => io.observe(el));
    }

    subnav() {
      const bar = this.root.querySelector('[data-pdp-subnav]');
      const hero = this.root.querySelector('.pdp-hero');
      if (!bar || !hero) return;

      const onScroll = () => {
        const past = window.scrollY > hero.offsetHeight - 80;
        bar.classList.toggle('is-shown', past);
        document.documentElement.classList.toggle('pdp-navaway', past);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      const links = Array.from(bar.querySelectorAll('[data-pdp-jump]'));
      const sections = links
        .map((link) => ({ link, el: this.root.querySelector(link.getAttribute('href')) }))
        .filter((pair) => pair.el);
      if (!sections.length || !('IntersectionObserver' in window)) return;

      const io = new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            sections.forEach((pair) => pair.link.classList.toggle('is-active', pair.el === entry.target));
          }),
        { rootMargin: '-40% 0px -50% 0px' }
      );
      sections.forEach((pair) => io.observe(pair.el));
    }

    quantity() {
      const input = this.root.querySelector('[data-pdp-qty-input]');
      const readout = this.root.querySelector('[data-pdp-qty-n]');
      if (!input) return;

      const sync = () => {
        const n = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = n;
        if (readout) readout.textContent = n;
      };

      this.root.querySelectorAll('[data-pdp-qty-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const step = parseInt(button.dataset.pdpQtyStep, 10);
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          sync();
        });
      });
      input.addEventListener('change', sync);
      sync();
    }

    buybar() {
      this.bar = this.root.querySelector('[data-pdp-buybar]');
      if (!this.bar || !('IntersectionObserver' in window)) return;
      // Duck under the site footer so the bar never covers it.
      const footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
      if (!footer) return;
      new IntersectionObserver((entries) => entries.forEach((entry) => this.bar.classList.toggle('is-hidden', entry.isIntersecting)), {
        threshold: 0.05,
      }).observe(footer);
    }

    hotspot() {
      const spot = this.root.querySelector('[data-pdp-spot]');
      if (!spot) return;
      spot.addEventListener('click', () => {
        if (!this.bar) return;
        this.bar.classList.remove('is-hidden');
        if (this.reduced || !this.bar.animate) return;
        this.bar.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.02)' }, { transform: 'scale(1)' }],
          { duration: 500, easing: 'ease', composite: 'add' }
        );
      });
    }

    /*
     * Spec: the three crops share ONE scale factor, so the piece is the same
     * physical size in each. Compute k from the largest natural dimensions in
     * the set and size every image naturalWidth x k.
     */
    save() {
      const button = this.root.querySelector('[data-pdp-save]');
      if (!button) return;
      // The hero "Save" and the buy-bar heart are one state.
      const hero = this.root.querySelector('[data-pdp-hsave]');
      const read = () => {
        try { return JSON.parse(window.localStorage.getItem('brando_saved') || '[]'); } catch (e) { return []; }
      };
      const paint = (list) => {
        const on = list.some((item) => item.handle === button.dataset.handle);
        button.classList.toggle('is-on', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (hero) { hero.classList.toggle('on', on); hero.setAttribute('aria-pressed', on ? 'true' : 'false'); }
      };
      paint(read());
      const flip = () => {
        let list = read();
        if (list.some((item) => item.handle === button.dataset.handle)) {
          list = list.filter((item) => item.handle !== button.dataset.handle);
        } else {
          list.unshift({
            handle: button.dataset.handle,
            title: button.dataset.title,
            image: button.dataset.image,
            url: button.dataset.url,
          });
        }
        list = list.slice(0, 20);
        try { window.localStorage.setItem('brando_saved', JSON.stringify(list)); } catch (e) { /* private mode */ }
        paint(list);
        const on = list.some((item) => item.handle === button.dataset.handle);
        if (window.BrandoNotify) window.BrandoNotify.saved(on);
      };
      button.addEventListener('click', flip);
      if (hero) hero.addEventListener('click', flip);
    }

    /*
     * Add to cart raises a toast with a "View cart" action; it does not open
     * the drawer itself. The nav cart icon is what opens the drawer.
     */
    addToast() {
      const form = this.root.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      form.addEventListener('submit', () => {
        const name = this.root.dataset.title || '';
        const fabric = this.root.querySelector('[data-pdp-swlabel]');
        const image = this.root.dataset.image || '';
        setTimeout(() => {
          if (!window.BrandoNotify) return;
          window.BrandoNotify.added({
            name: name,
            variant: fabric ? fabric.textContent.trim() : '',
            image: image
          });
        }, 350);
      });
    }

    fitViews() {
      const row = this.root.querySelector('[data-pdp-views]');
      if (!row) return;
      const images = Array.from(row.querySelectorAll('img'));
      if (!images.length) return;

      const fit = () => {
        const loaded = images.filter((img) => img.naturalWidth > 0);
        if (!loaded.length) return;

        // Spec: every view - the pinned front and each drawing in the flow -
        // shares ONE scale factor. Equal pixel scale means equal physical
        // scale, so the narrow side crop stays narrow instead of being blown
        // up to fill its column.
        const flow = row.querySelector('.pdp-views__flow');
        const col = flow ? flow.clientWidth : row.getBoundingClientRect().width / 2;
        const capH = window.matchMedia('(max-width: 900px)').matches ? 241 : 340;

        let k = Infinity;
        loaded.forEach((img) => {
          k = Math.min(k, col / img.naturalWidth, capH / img.naturalHeight);
        });
        if (!isFinite(k) || k <= 0) return;

        loaded.forEach((img) => {
          img.style.width = `${Math.round(img.naturalWidth * k)}px`;
          img.style.height = `${Math.round(img.naturalHeight * k)}px`;
          img.style.maxWidth = 'none';
          img.style.maxHeight = 'none';
        });
      };

      let pending = images.length;
      images.forEach((img) => {
        if (img.complete && img.naturalWidth) {
          if (--pending === 0) fit();
        } else {
          img.addEventListener('load', () => { if (--pending === 0) fit(); }, { once: true });
          img.addEventListener('error', () => { if (--pending === 0) fit(); }, { once: true });
        }
      });
      window.addEventListener('resize', fit);
    }

    units() {
      const toggle = this.root.querySelector('[data-pdp-unit]');
      if (!toggle) return;
      const values = Array.from(this.root.querySelectorAll('[data-pdp-cm]'));
      toggle.querySelectorAll('[data-pdp-u]').forEach((button) => {
        button.addEventListener('click', () => {
          toggle.querySelectorAll('[data-pdp-u]').forEach((other) => other.classList.toggle('is-on', other === button));
          const inches = button.dataset.pdpU === 'in';
          values.forEach((dd) => {
            const cm = parseFloat(dd.dataset.pdpCm);
            if (isNaN(cm)) return;
            dd.textContent = inches ? `${(cm / 2.54).toFixed(1).replace(/\.0$/, '')} in` : `${cm} cm`;
          });
        });
      });
    }

    /* The drawings wipe in from the left once the band is in view. */
    drawIn() {
      const band = this.root.querySelector('.pdp-dims');
      if (!band) return;
      if (this.reduced || !('IntersectionObserver' in window)) {
        band.classList.add('is-drawn');
        return;
      }
      const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        band.classList.add('is-drawn');
        io.unobserve(band);
      }), { threshold: 0, rootMargin: '0px 0px -12% 0px' });
      io.observe(band);
    }

    variants() {
      const swlabel = this.root.querySelector('[data-pdp-swlabel]');
      const barlabel = this.root.querySelector('[data-pdp-barlabel]');
      const inst = this.root.querySelector('[data-pdp-inst]');
      if (!swlabel && !barlabel && !inst) return;

      const apply = (variant) => {
        if (!variant) return;
        const title = (variant.title || '').replace(/ \/ /g, ' · ');
        if (swlabel && title) swlabel.textContent = title;
        if (barlabel && title) barlabel.textContent = title;
        if (inst && typeof variant.price === 'number') {
          inst.textContent = `4× ${this.money(variant.price / 4)}`;
        }
      };

      // Immediate feedback on click, then the authoritative value from Dawn.
      const selects = this.root.querySelector('variant-selects');
      if (selects) {
        selects.addEventListener('change', () => {
          const chosen = Array.from(selects.querySelectorAll('fieldset input:checked')).map((input) => input.value);
          const title = chosen.join(' · ');
          if (swlabel) swlabel.textContent = title;
          if (barlabel) barlabel.textContent = title;
        });
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.root.dataset.section) return;
          apply(event.data.variant);
        });
      }
    }

    /*
     * Formats a price in the shop's currency from the cents value Dawn hands us.
     * Falls back to the money format already rendered on the page.
     */
    money(cents) {
      const amount = Math.round(cents) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'AED',
          maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
        }).format(amount);
      } catch (error) {
        return amount.toLocaleString();
      }
    }
  }

  const initBrandoPdp = () => {
    document.querySelectorAll('.pdp').forEach((root) => {
      if (root.dataset.pdpReady) return;
      root.dataset.pdpReady = 'true';
      new BrandoPdp(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandoPdp);
  else initBrandoPdp();
  document.addEventListener('shopify:section:load', initBrandoPdp);

  } catch(e) { console.error(e); }
})();
})();
